export const getImportsPath = state => state.paths.imports;
export const getImportRequestsPath = state => state.paths.importRequests;
